import Component from "@ember/component"
import { action, computed, get, set } from "@ember/object"
import { inject as service } from "@ember/service"
import _ from "lodash"

export default class SyncButton extends Component {
  @service("ember-store") store
  @service socket

  isHovering = true

  mouseEnter() {
    set(this, "isHovering", true)
  }

  mouseLeave() {
    set(this, "isHovering", false)
  }

  @computed("socket.recentlyPublishedActions.@each.id")
  get recentlyPublishedActionsWithTitles() {
    return _.reject(get(this, "socket.recentlyPublishedActions"), (action) => {
      return action.attributes.sync.isUserFacing !== true
    })
  }

  @action
  undoIt() {
    get(this, "undoService").pop()
  }
}
